import { Share as CapacitorShare } from '@capacitor/share';
import Analytics from '@withlocals/withlocals-analytics';
import { WlWindow } from 'typings/globals/cordova';
import Logger from 'utils/Logger';

declare const window: WlWindow;

export const getShareOption = (): 'social-share' | 'navigator' | 'none' => {
  if (!!CapacitorShare.share) {
    return 'social-share';
  }
  if (window.navigator && window.navigator.share) {
    return 'navigator';
  }
  return 'none';
};

const Share = async ({
  message,
  subject,
  url,
  chooserTitle,
  analyticsCategory,
}) => {
  const shareOption = getShareOption();

  const options = {
    text: message,
    title: subject,
    url,
    dialogTitle: chooserTitle,
  };

  switch (shareOption) {
    case 'social-share':
      try {
        const { activityType } = await CapacitorShare.share(options);
        Analytics.track(analyticsCategory, 'Share', activityType);
        Logger.log('Shared to app: ' + activityType);
      } catch (error) {
        Logger.error('Error sharing', error);
      }
      break;
    case 'navigator':
      try {
        await window.navigator.share({
          options,
        });
        Logger.log('Successful share');
      } catch (error) {
        Logger.error('Error sharing', error);
      }
      break;
    default:
      return;
  }
};

export default Share;
